import React from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Grid from "@mui/material/Grid";
//Sections
import SignUpWelcome from "../../sections/sign-up-welcome/SignUpWelcome";
import PropAndRewards from "../../sections/prop-rewards/PropAndRewards";
import StepsContent from "../../sections/steps-content/StepsContent";
import Testimonials from "../../sections/testimonials/Testimonials";
import ExampleQuestions from "../../sections/example-questions/ExampleQuestions";
import RichText from "../../sections/rich-text/RichText";
import SignUpCta from "../../sections/sign-up-cta/SignUpCta";
import TemplateRenderer from "../../components/template-renderer/TemplateRenderer";
import BrandLearningTabHeader from "../../sections/brand-learning-tab-header/BrandLearningTabHeader";
import TextWithMeadia from "../../sections/text-with-media/TextWithMeadia";
import TestimonialsWithMedia from "../../sections/testimonials-with-media/TestimonialsWithMedia";
import CanCannotAnswer from "../../sections/can-cannot-answer/CanCannotAnswer";

// SSR-safe location hook
const useSafeLocation = () => {
  try {
    return useLocation();
  } catch (e) {
    return {
      pathname: '',
      search: '',
      hash: '',
      state: null,
      key: 'default'
    };
  }
};
export const useGroupSignUpStyles = (theme, isSpecialPath) => {
  return {
    container: {
      backgroundColor: theme.palette.background.default,
      maxWidth: 1440,
      margin: "auto",
      width: "100%"
    },
    leftSpaceContainer: {
      paddingLeft: 30,
      paddingRight: 30
    },
    subHeaderContainer: {
      paddingLeft: 0,
      [theme.breakpoints.up("sm")]: {
        paddingLeft: isSpecialPath ? 0 : 83
      },
      [theme.breakpoints.up("md")]: {
        paddingLeft: isSpecialPath ? 0 : 90
      }
    }
  };
};
const SECTIONS = {
  "sign-up-welcome": SignUpWelcome,
  header: BrandLearningTabHeader,
  "text-with-media": TextWithMeadia,
  "can-cannot-answer": CanCannotAnswer,
  "prop-rewards": PropAndRewards,
  steps: StepsContent,
  testimonials: Testimonials,
  "example-questions": ExampleQuestions,
  "rich-text": RichText,
  "testimonials-with-media": TestimonialsWithMedia,
  "sign-up-cta": SignUpCta
};
const GroupSignUpTemplate = ({
  content,
  endDate,
  genericGroupHash
}) => {
  var _content$sections$;
  const location = useSafeLocation();
  const isSpecialPath = location.pathname === "/onboarding/opt-in";
  const useStyles = makeStyles(theme => ({
    ...useGroupSignUpStyles(theme, isSpecialPath)
  }));
  const classes = useStyles();
  if (!content || !content.sections) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Grid, {
    className: classes.container
  }, /*#__PURE__*/React.createElement(TemplateRenderer, {
    content: content,
    sectionComponentMapping: SECTIONS,
    endDate: endDate,
    hash: content._groupHash,
    genericGroupHash: genericGroupHash,
    useAltDesign: (_content$sections$ = content.sections[0]) === null || _content$sections$ === void 0 ? void 0 : _content$sections$.useAltDesign,
    leftSpaceContainer: classes.leftSpaceContainer,
    subHeaderContainer: classes.subHeaderContainer
  }));
};
export default GroupSignUpTemplate;
GroupSignUpTemplate.propTypes = {
  content: PropTypes.object.isRequired,
  endDate: PropTypes.number,
  genericGroupHash: PropTypes.string
};